import { Box } from "@chakra-ui/react";

export function CertificateIcon({ width, height, ...props }: any) {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M10.9999 18.7734L7.04057 20.0267C6.7703 20.1219 6.52234 20.0858 6.29669 19.9185C6.07104 19.7512 5.95821 19.5282 5.95821 19.2493V13.8163C5.37766 13.2099 4.92696 12.5083 4.60613 11.7114C4.28529 10.9146 4.12488 10.0662 4.12488 9.16602C4.12488 7.24682 4.79076 5.62119 6.12252 4.28912C7.45429 2.95705 9.07961 2.29102 10.9985 2.29102C12.9174 2.29102 14.5432 2.95705 15.8759 4.28912C17.2085 5.62119 17.8749 7.24682 17.8749 9.16602C17.8749 10.0662 17.7145 10.9146 17.3936 11.7114C17.0728 12.5083 16.6221 13.2099 16.0415 13.8163V19.2493C16.0415 19.5282 15.9287 19.7512 15.7031 19.9185C15.4774 20.0858 15.2295 20.1219 14.9592 20.0267L10.9999 18.7734ZM10.9999 14.666C12.5277 14.666 13.8263 14.1313 14.8957 13.0618C15.9652 11.9924 16.4999 10.6938 16.4999 9.16602C16.4999 7.63824 15.9652 6.33963 14.8957 5.27018C13.8263 4.20074 12.5277 3.66602 10.9999 3.66602C9.4721 3.66602 8.17349 4.20074 7.10404 5.27018C6.0346 6.33963 5.49988 7.63824 5.49988 9.16602C5.49988 10.6938 6.0346 11.9924 7.10404 13.0618C8.17349 14.1313 9.4721 14.666 10.9999 14.666ZM7.33321 18.3643L10.9999 17.3807L14.6665 18.3643V14.9587C14.1436 15.2995 13.5706 15.5651 12.9476 15.7555C12.3247 15.9458 11.6749 16.041 10.998 16.041C10.3212 16.041 9.67193 15.9458 9.05013 15.7555C8.42848 15.5651 7.85617 15.2995 7.33321 14.9587V18.3643Z"
          fill="#FFB433"
        />
      </svg>
    </Box>
  );
}
